import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MustMatch } from 'src/app/helpers/must-match.validator';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.page.html',
  styleUrls: ['./new-password.page.scss'],
})
export class NewPasswordPage implements OnInit, OnDestroy {

  passwordForm: FormGroup;
  changePassword$: Subscription

  constructor(
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private authService: AuthService,
    private router: Router,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.initConstructor();
  }

  ngOnDestroy() {
    this.changePassword$.unsubscribe();
  }

  private initConstructor() {
    this.passwordForm = this.formBuilder.group({
      password: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$")
        ]),
      ],
      confirmPassword: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$")
        ]),
      ]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
  }

  get f() { return this.passwordForm.controls; }

  seePassword(input, icon){
    input.type = input.type == 'text' ? 'password': 'text';
    icon.name = icon.name == 'eye-outline' ? 'eye-off-outline' : 'eye-outline';
  }

  async updatePassword(){
    const token = await this.storageService.get('token-otp');
    const body = {
      token,
      'password': this.f.password.value
    }
    this.changePassword$ = this.authService.changePassword(body).subscribe(async (res: any) => {
      if(res.updated){
        this.alertService.presentAlert('Contraseña actualizada correctamente. Inicia sesión con tu documento');
        // this.router.navigateByUrl('login');
        await this.authService.logout()
      }
    }, error => {
      console.error(error);
    })

  }
 public canDeactivate(){
    return this.passwordForm.valid
  }

}
